define('shoptheme/components/ui/scrolltop',[
	"jquery",
	"cartware/jquery/bem",
	"cartware/components/_base"
], function(
	$,
	BEM,
	Component
) {
	return Component.create({
		blocks:			null,

		$init: function() {
			this.blocks = BEM.block('scrolltopbutton');
			this.blocks.each(function() {
				var block = BEM.block(this);
				var link = block.getElements('link');

				link.click(function(e){
					e.preventDefault();
					$('body, html').animate({
						scrollTop: 0
					}, 200);
				});

				if( $(window).scrollTop() > 200 ) {
					block.addClass('active');
				}

				$(window).scroll(function () {
					if( $(window).scrollTop() > 200 ) {
						block.addClass('active');
					}

					if( $(window).scrollTop() < 200 ) {
						block.removeClass('active');
					}
				});
			});
		}
	});
});



